<template lang="pug">
router-link.menu-item(
    active-class="menu-item__active"
    :to="link.url"
)
    span.menu-item__title
        | {{ link.name }}

    SvIcon(
        icon="arrow"
        :width="8"
        :height="15"
    )
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'MenuItem',

  components: {
    SvIcon,
  },

  props: {
    link: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
    height: 43px;
    border-radius: 50px;
    padding: 0 16px 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    color: #fff;
    transition: background ease-in-out .3s;
    font-weight: 500;
    margin-bottom: 10px;

    &__active {
        background-color: rgba(13, 91, 163, .2);

        &:hover {
            background-color: rgba(13, 91, 163, .4);
        }
    }

    &:hover {
        background-color: rgba(13, 91, 163, .3);
    }
};
</style>
